module.exports = __webpack_public_path__ + "img/8_13.6f8822da.png";